"use client";

import { useEffect } from "react";
declare global {
  interface Window {
    AddToHomeScreen?: (options: any) => any;
    AddToHomeScreenInstance?: any;
  }
}
export default function ClientScript() {
  useEffect(() => {
    // This code will run on the client side after the DOM is loaded
    if (
      typeof window !== "undefined" &&
      typeof window.AddToHomeScreen === "function"
    ) {
      // Add App to Phone
      window.AddToHomeScreenInstance = window.AddToHomeScreen({
        appName: "FundayList", // Name of the app.
        appNameDisplay: "standalone", // If set to 'standalone' (the default), the app name will be diplayed
        // on it's own, beneath the "Install App" header. If set to 'inline', the
        // app name will be displayed on a single line like "Install MyApp"
        // Optional. Default 'standalone'
        appIconUrl: "android-chrome-512x512.png", // App icon link (square, at least 40 x 40 pixels).
        assetUrl:
          "https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@3.0/dist/assets/img/", // Link to directory of library image assets.

        maxModalDisplayCount: -1, // If set, the modal will only show this many times.
        // [Optional] Default: -1 (no limit).  (Debugging: Use this.clearModalDisplayCount() to reset the count)
        displayOptions: { showMobile: true, showDesktop: true }, // show on mobile/desktop [Optional] Default: show everywhere
        allowClose: true, // allow the user to close the modal by tapping outside of it [Optional. Default: true]
      });

      // [optional] language.  If left blank, then language is auto-decided from (1) URL param locale='..' (e.g. /?locale=es) (2) Browser language settings
    }
  }, []);

  return null;
}
